import Callout from "../../../../src/components/callouts/callouts";
import Links from "../../../../src/components/links/links";
import { PREFIX_REPOSITORY, POSTFIX_REPOSITORY } from "../../../../src/constants/URLs";
import * as React from 'react';
export default {
  Callout,
  Links,
  PREFIX_REPOSITORY,
  POSTFIX_REPOSITORY,
  React
};